import { render, staticRenderFns } from "./noticeSetting.vue?vue&type=template&id=64160ec7&scoped=true&"
import script from "./noticeSetting.vue?vue&type=script&lang=js&"
export * from "./noticeSetting.vue?vue&type=script&lang=js&"
import style0 from "./noticeSetting.vue?vue&type=style&index=0&id=64160ec7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64160ec7",
  null
  
)

export default component.exports